import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { apiGet, apiPost, TOKEN_KEY } from "@/lib/shieldx";

const AuthContext = createContext(null);

function storeToken(u) {
  if (u && u.token) localStorage.setItem(TOKEN_KEY, u.token);
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, obj = authed

  const checkAuth = useCallback(async () => {
    try {
      const u = await apiGet("/auth/me");
      setUser(u);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    // If returning from Google OAuth, let AuthCallback establish the session first.
    if (window.location.hash?.includes("session_id=")) return;
    checkAuth();
  }, [checkAuth]);

  const login = async (email, password) => {
    const u = await apiPost("/auth/login", { email, password });
    storeToken(u);
    setUser(u);
    return u;
  };
  const register = async (payload) => {
    const u = await apiPost("/auth/register", payload);
    storeToken(u);
    setUser(u);
    return u;
  };
  const logout = async () => {
    try { await apiPost("/auth/logout", {}); } catch {}
    localStorage.removeItem(TOKEN_KEY);
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, register, logout, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
